import { render, staticRenderFns } from "./ClaimManager.vue?vue&type=template&id=4bb73e1a"
import script from "./ClaimManager.vue?vue&type=script&lang=js"
export * from "./ClaimManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports